import {compose} from 'redux';
import withStatusList from '../../../_common/components/StatusList/components/withStatusList';
import OrdersPageFilters from './OrdersPageFilters';

export default compose(
  withStatusList
)(OrdersPageFilters);
